module.exports = __webpack_public_path__ + "7c44ec6a10c0ea4641a4c7991bc644db.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-condensed-regular-webfont.woff
// module id = 357
// module chunks = 0